var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCriticalAssetOutlinedBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24__Size=24, Type=Outlined, Color=Blue, State=Enabled",
    className: "24__Size=24, 24__Type=Outlined, 24__Color=Blue, 24__State=Enabled"
  }, /*#__PURE__*/React.createElement("g", {
    id: "24__Vector",
    className: "24__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0054EC",
    fillOpacity: 0.08,
    d: "m19.26 5.134 2.264 4.611-9.54 11.573L2.476 9.745l2.326-4.623a1.429 1.429 0 0 1 1.276-.787h11.9c.545 0 1.042.31 1.282.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0132A2",
    fillRule: "evenodd",
    d: "M6.078 4.811c-.36 0-.69.203-.85.525l-1.98 3.933h4.638L10.1 4.811H6.078Zm5.086 0L8.95 9.27h5.893l-2.08-4.458h-1.598Zm2.65 0 2.08 4.458h4.866l-1.927-3.925a.952.952 0 0 0-.855-.533h-4.165Zm6.7 5.41H12.46v9.771l8.054-9.77Zm-9.006 9.767v-9.766H3.484l8.024 9.766ZM4.376 4.908a1.905 1.905 0 0 1 1.702-1.05h11.9c.727 0 1.39.414 1.71 1.066l2.263 4.612a.476.476 0 0 1-.06.512l-9.54 11.573a.476.476 0 0 1-.735 0L2.108 10.048a.476.476 0 0 1-.057-.516l2.325-4.624Z",
    clipRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalAssetOutlinedBlue);
export default __webpack_public_path__ + "static/media/critical_asset_outlined_blue.4638b213aff1076018e480adeb372d97.svg";
export { ForwardRef as ReactComponent };